(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3319],{

/***/ 54931:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medicine-dictionary",
      function () {
        return __webpack_require__(85351);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 23889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89961);
/* harmony import */ var _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10712);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var LinkTag = function(param) {
    var href = param.href, _target = param.target, target = _target === void 0 ? "_self" : _target, children = param.children, style = param.style, onClickNavigateToScreen = param.onClickNavigateToScreen;
    return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .isWebView */ .vp)() ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        role: "button",
        onClick: onClickNavigateToScreen,
        style: style,
        children: children
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        style: style,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
            target: target,
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LinkTag);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-db5d6e27-0"
})(_templateObject());


/***/ }),

/***/ 16708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "me": function() { return /* binding */ useMedicineDictionaryItemByPublicIdQuery; },
/* harmony export */   "vi": function() { return /* binding */ usePopularMedicineDictionaryItemsQuery; }
/* harmony export */ });
/* unused harmony exports MedicineDictionaryItemByPublicIdDocument, PopularMedicineDictionaryItemsDocument */
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36492);
/* harmony import */ var _utils_fetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8391);


var MedicineDictionaryItemByPublicIdDocument = "\n    query MedicineDictionaryItemByPublicId($publicId: String!) {\n  medicineDictionaryItemByPublicId(publicId: $publicId) {\n    id\n    publicId\n    basicInfo {\n      name\n      simplifiedName\n      pharmaceuticalEffectLiteracy\n      medicineImage\n      medicinePictogramImages\n    }\n    classificationInfo {\n      ethicalType\n    }\n    companyInfo {\n      companyName\n    }\n    ingredientInfo {\n      formattedIngredientName\n    }\n    medicineGuide {\n      interactionHtml\n      indications\n      dosages\n      dosageHtml\n      sideEffects\n      cautions\n      storages\n      videoLink\n    }\n    packagingInfo {\n      image\n    }\n  }\n}\n    ";
var useMedicineDictionaryItemByPublicIdQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "MedicineDictionaryItemByPublicId",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(MedicineDictionaryItemByPublicIdDocument, "MedicineDictionaryItemByPublicId", variables), options);
};
useMedicineDictionaryItemByPublicIdQuery.getKey = function(variables) {
    return [
        "MedicineDictionaryItemByPublicId",
        variables
    ];
};
useMedicineDictionaryItemByPublicIdQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(MedicineDictionaryItemByPublicIdDocument, "MedicineDictionaryItemByPublicId", variables, options);
};
var PopularMedicineDictionaryItemsDocument = "\n    query PopularMedicineDictionaryItems {\n  popularMedicineDictionaryItems {\n    id\n    publicId\n    basicInfo {\n      name\n      simplifiedName\n      pharmaceuticalEffectLiteracy\n      medicineImage\n    }\n    medicineGuide {\n      wholeSummary\n    }\n    packagingInfo {\n      image\n    }\n  }\n}\n    ";
var usePopularMedicineDictionaryItemsQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)(variables === undefined ? [
        "PopularMedicineDictionaryItems"
    ] : [
        "PopularMedicineDictionaryItems",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(PopularMedicineDictionaryItemsDocument, "PopularMedicineDictionaryItems", variables), options);
};
usePopularMedicineDictionaryItemsQuery.getKey = function(variables) {
    return variables === undefined ? [
        "PopularMedicineDictionaryItems"
    ] : [
        "PopularMedicineDictionaryItems",
        variables
    ];
};
usePopularMedicineDictionaryItemsQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(PopularMedicineDictionaryItemsDocument, "PopularMedicineDictionaryItems", variables, options);
};


/***/ }),

/***/ 51196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22710);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22970);
/* harmony import */ var _entities_medicine_dictionary_model_medicineDictionary_model__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72115);
/* harmony import */ var _medicine_dictionary_gql_impl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16708);




var parsePopularMedicineDictionaryItems = function(data) {
    return data.popularMedicineDictionaryItems.map(function(item) {
        var _medicineImage, _image;
        return new _entities_medicine_dictionary_model_medicineDictionary_model__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z({
            id: item.id,
            publicId: item.publicId,
            basicInfo: {
                name: item.basicInfo.name,
                simplifiedName: item.basicInfo.simplifiedName,
                pharmaceuticalEffectLiteracy: item.basicInfo.pharmaceuticalEffectLiteracy,
                medicineImage: (_medicineImage = item.basicInfo.medicineImage) !== null && _medicineImage !== void 0 ? _medicineImage : undefined
            },
            medicineGuide: {
                wholeSummary: item.medicineGuide.wholeSummary.join(" ")
            },
            packagingInfo: {
                image: (_image = item.packagingInfo.image) !== null && _image !== void 0 ? _image : undefined
            }
        });
    });
};
var usePopularMedicineDictionaryItems = function() {
    var ref = (0,_medicine_dictionary_gql_impl__WEBPACK_IMPORTED_MODULE_0__/* .usePopularMedicineDictionaryItemsQuery */ .vi)({}, {
        select: parsePopularMedicineDictionaryItems,
        staleTime: 1000 * 60 * 5
    }), popularMedicineDictionaryItems = ref.data, isPopularMedicineDictionaryItemsLoading = ref.isLoading;
    return {
        popularMedicineDictionaryItems: popularMedicineDictionaryItems,
        isPopularMedicineDictionaryItemsLoading: isPopularMedicineDictionaryItemsLoading
    };
};
usePopularMedicineDictionaryItems.prefetchQuery = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(queryClient) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                queryClient.prefetchQuery({
                    queryKey: _medicine_dictionary_gql_impl__WEBPACK_IMPORTED_MODULE_0__/* .usePopularMedicineDictionaryItemsQuery.getKey */ .vi.getKey({}),
                    queryFn: _medicine_dictionary_gql_impl__WEBPACK_IMPORTED_MODULE_0__/* .usePopularMedicineDictionaryItemsQuery.fetcher */ .vi.fetcher({}),
                    staleTime: 1000 * 60 * 5
                })
            ];
        });
    });
    return function(queryClient) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (usePopularMedicineDictionaryItems);


/***/ }),

/***/ 77196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62230);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12436);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78287);
/* harmony import */ var _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10712);






var useCustomRouter = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var moveToPage = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(param) {
        var webLink = param.webLink, mobileScreenName = param.mobileScreenName, params = param.params, as = param.as, _type = param.type, type = _type === void 0 ? _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .NATIVE_POST_MESSAGE_TYPE.MOVE_TO_PAGE */ .nn.MOVE_TO_PAGE : _type;
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .isWebView */ .vp)()) {
            (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .sendPostMessageToNative */ .T0)(type, {
                screenName: mobileScreenName,
                params: params ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, params) : undefined
            });
        } else {
            if (!webLink) return;
            if (type === _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .NATIVE_POST_MESSAGE_TYPE.REPLACE_TO_PAGE */ .nn.REPLACE_TO_PAGE) {
                router.replace(webLink, as);
                return;
            }
            router.push(webLink, as);
        }
    }, [
        router
    ]);
    var getCustomPageName = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(defaultPageName) {
        return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .isWebView */ .vp)() ? defaultPageName : (0,_utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .getMobileWebPageName */ .b9)(router);
    }, [
        router
    ]);
    var pageName = (0,_utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .getPageName */ .j0)(router);
    return {
        router: router,
        moveToPage: lodash_throttle__WEBPACK_IMPORTED_MODULE_0___default()(moveToPage, 1500, {
            trailing: false
        }),
        getCustomPageName: getCustomPageName,
        pageName: pageName
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useCustomRouter);


/***/ }),

/***/ 85351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ medicine_dictionary; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/components/atom/BreadCrumbs.tsx
var BreadCrumbs = __webpack_require__(27441);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/constants/zIndex.ts
var zIndex = __webpack_require__(31591);
// EXTERNAL MODULE: ./src/designComponents/organisms/DNSearchBar/index.tsx
var DNSearchBar = __webpack_require__(52477);
// EXTERNAL MODULE: ./src/components/common/LinkTag/index.tsx
var LinkTag = __webpack_require__(23889);
// EXTERNAL MODULE: ./src/entities/medicine-dictionary/ui/MedicineDictionary.tsx
var MedicineDictionary = __webpack_require__(7265);
// EXTERNAL MODULE: ./src/entities/medicine-dictionary/util/index.ts
var util = __webpack_require__(68534);
// EXTERNAL MODULE: ./src/hooks/medicine-dictionary/usePopularMedicineDictionaryItems.ts
var usePopularMedicineDictionaryItems = __webpack_require__(51196);
// EXTERNAL MODULE: ./src/hooks/useCustomRouter.tsx
var useCustomRouter = __webpack_require__(77196);
;// CONCATENATED MODULE: ./src/features/medicineDictionary/hook/useSearchPopularMedicineDictionaryViewModel.ts



var useSearchPopularMedicineDictionaryViewModel = function() {
    var router = (0,useCustomRouter/* default */.Z)().router;
    var popularMedicineDictionaryItems = (0,usePopularMedicineDictionaryItems/* default */.Z)().popularMedicineDictionaryItems;
    var items = (popularMedicineDictionaryItems === null || popularMedicineDictionaryItems === void 0 ? void 0 : popularMedicineDictionaryItems.slice(0, 6)) || [];
    var onClickMedicineDictionary = function(medicineDictionary) {
        return function() {
            router.push((0,util/* createMedicineDictionaryDetailUrl */.at)(medicineDictionary));
        };
    };
    return {
        popularMedicineDictionaryItems: items,
        onClickMedicineDictionary: onClickMedicineDictionary
    };
};
/* harmony default export */ var hook_useSearchPopularMedicineDictionaryViewModel = (useSearchPopularMedicineDictionaryViewModel);

;// CONCATENATED MODULE: ./src/features/medicineDictionary/ui/SearchPopularMedicineDictionary.tsx





var SearchPopularMedicineDictionary = function() {
    var viewModel = hook_useSearchPopularMedicineDictionaryViewModel();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-[24px] pt-[24px] pb-[32px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "typography-ui-20sb mb-4 text-gray-700 ",
                children: "많이 검색된 약품"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-1 gap-[28px] md:grid-cols-2",
                suppressHydrationWarning: true,
                children: viewModel.popularMedicineDictionaryItems.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTag/* default */.Z, {
                        href: (0,util/* createMedicineDictionaryDetailUrl */.at)(item),
                        onClickNavigateToScreen: viewModel.onClickMedicineDictionary(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MedicineDictionary/* default */.Z, {
                            title: item.getBasicInfoName(),
                            description: item.getPharmaceuticalEffectLiteracy(),
                            summary: item.getWholeSummary(),
                            image: item.getRepresentativeImage(),
                            imageAlt: item.getSimplifiedName()
                        })
                    }, item.getPublicId());
                })
            })
        ]
    });
};
/* harmony default export */ var ui_SearchPopularMedicineDictionary = (SearchPopularMedicineDictionary);

// EXTERNAL MODULE: ./src/components/common/PaginationComponent.tsx + 3 modules
var PaginationComponent = __webpack_require__(52248);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ./src/hooks/search/useGetKeywordIntegratedSearchMedicineDictionary.ts
var useGetKeywordIntegratedSearchMedicineDictionary = __webpack_require__(28909);
;// CONCATENATED MODULE: ./src/features/medicineDictionary/hook/useSearchTotalMedicineDictionaryViewModel.ts




var useSearchTotalMedicineDictionaryViewModel = function() {
    var router = (0,useCustomRouter/* default */.Z)().router;
    var queries = router.isReady ? router.query : {
        keyword: "",
        page: "1"
    };
    var _page = queries.page, page = _page === void 0 ? "1" : _page;
    var currentPage = Number(page) || 1;
    var ref = (0,useGetKeywordIntegratedSearchMedicineDictionary/* default */.Z)({
        keyword: undefined,
        enabled: true,
        limit: 10,
        page: currentPage
    }), keywordSearchMedicineDictionary = ref.keywordSearchMedicineDictionary, totalPage = ref.totalPage;
    var medicineDictionaryItems = (keywordSearchMedicineDictionary === null || keywordSearchMedicineDictionary === void 0 ? void 0 : keywordSearchMedicineDictionary.elements) || [];
    var paginationBaseUrl = common/* ROUTES.MEDICINE_DICTIONARY.HOME.path */.Z6.MEDICINE_DICTIONARY.HOME.path;
    var onClickMedicineDictionary = function(medicineDictionary) {
        return function() {
            router.push((0,util/* createMedicineDictionaryDetailUrl */.at)(medicineDictionary));
        };
    };
    return {
        medicineDictionaryItems: medicineDictionaryItems,
        currentPage: currentPage,
        totalPage: totalPage,
        queries: queries,
        paginationBaseUrl: paginationBaseUrl,
        onClickMedicineDictionary: onClickMedicineDictionary
    };
};
/* harmony default export */ var hook_useSearchTotalMedicineDictionaryViewModel = (useSearchTotalMedicineDictionaryViewModel);

;// CONCATENATED MODULE: ./src/features/medicineDictionary/ui/SearchTotalMedicineDictionary.tsx






var SearchTotalMedicineDictionary = function() {
    var viewModel = hook_useSearchTotalMedicineDictionaryViewModel();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-[16px] px-[24px] pt-[32px] pb-[80px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "typography-ui-20sb mb-4 text-gray-700 ",
                        children: "전체 약품"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid grid-cols-1 gap-[28px] md:grid-cols-2",
                        suppressHydrationWarning: true,
                        children: viewModel.medicineDictionaryItems.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTag/* default */.Z, {
                                href: "".concat(common/* ROUTES.MEDICINE_DICTIONARY.DETAIL.path */.Z6.MEDICINE_DICTIONARY.DETAIL.path, "/").concat(item.getPublicId()),
                                onClickNavigateToScreen: viewModel.onClickMedicineDictionary(item),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MedicineDictionary/* default */.Z, {
                                    title: item.getBasicInfoName(),
                                    description: item.getPharmaceuticalEffectLiteracy(),
                                    summary: item.getWholeSummary(),
                                    image: item.getRepresentativeImage(),
                                    imageAlt: item.getSimplifiedName()
                                })
                            }, item.getPublicId());
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationComponent/* default */.Z, {
                baseUrl: viewModel.paginationBaseUrl,
                queries: viewModel.queries,
                currentPage: viewModel.currentPage,
                perPage: 5,
                totalPage: viewModel.totalPage,
                scroll: false
            })
        ]
    });
};
/* harmony default export */ var ui_SearchTotalMedicineDictionary = (SearchTotalMedicineDictionary);

// EXTERNAL MODULE: ./src/types/app.ts
var app = __webpack_require__(9912);
;// CONCATENATED MODULE: ./src/components/templates/medicine-dictionary/MedicineDictionaryTemplate.tsx









var MedicineDictionaryTemplate = function(props) {
    var ref, ref1;
    var shouldShowBreadCrumbs = ((ref = props.client) === null || ref === void 0 ? void 0 : ref.clientType) === app/* ClientType.WEB */.B.WEB;
    var topPosition = ((ref1 = props.client) === null || ref1 === void 0 ? void 0 : ref1.clientType) === app/* ClientType.MOBILE_WEB */.B.MOBILE_WEB ? "60px" : "0px";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                suppressHydrationWarning: true,
                children: shouldShowBreadCrumbs && /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default.Wrapper */.Z.Wrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                        visible: true,
                        name: "의약품 사전",
                        type: "medicine_dictionary",
                        path: "".concat(common/* ROUTES.MEDICINE_DICTIONARY.HOME.path */.Z6.MEDICINE_DICTIONARY.HOME.path)
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "typography-ui-22sb px-[24px] py-[16px] text-gray-900",
                children: "의약품 사전"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-[24px] py-[16px]",
                style: {
                    zIndex: zIndex/* zIndex.AppHeader */.W.AppHeader,
                    top: topPosition
                },
                suppressHydrationWarning: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DNSearchBar/* default */.Z, {
                    value: props.viewModel.keyword,
                    placeholder: "약 이름 또는 성분 등",
                    shouldShowResetButton: !!props.viewModel.keyword,
                    searchInputRef: props.viewModel.searchInputRef,
                    onSubmit: props.viewModel.handleSubmit,
                    onReset: props.viewModel.handleResetSearchKeyword,
                    onChange: props.viewModel.handleChangeSearchKeyword
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_SearchPopularMedicineDictionary, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-[16px] bg-gray-30"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_SearchTotalMedicineDictionary, {})
        ]
    });
};
/* harmony default export */ var medicine_dictionary_MedicineDictionaryTemplate = (MedicineDictionaryTemplate);

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/hooks/medicine-dictionary/useMedicineDictionaryViewModel.ts



var useMedicineDictionaryViewModel = function() {
    var router = (0,useCustomRouter/* default */.Z)().router;
    var queries = router.isReady ? router.query : {
        keyword: "",
        page: "1"
    };
    var searchInputRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(queries.keyword || ""), keyword = ref[0], setKeyword = ref[1];
    var handleSubmit = function() {
        var ref;
        var searchKeyword = ((ref = searchInputRef.current) === null || ref === void 0 ? void 0 : ref.value) || "";
        if (searchKeyword) {
            router.push({
                pathname: common/* ROUTES.MEDICINE_DICTIONARY.SEARCH.path */.Z6.MEDICINE_DICTIONARY.SEARCH.path,
                query: {
                    keyword: searchKeyword
                }
            });
        }
    };
    var handleResetSearchKeyword = function() {
        if (searchInputRef.current) {
            searchInputRef.current.value = "";
        }
        router.push({
            pathname: common/* ROUTES.MEDICINE_DICTIONARY.HOME.path */.Z6.MEDICINE_DICTIONARY.HOME.path,
            query: {}
        });
    };
    var handleBackButtonClick = function() {
        router.back();
    };
    var handleChangeSearchKeyword = function(e) {
        setKeyword(e.target.value);
    };
    return {
        keyword: keyword,
        searchInputRef: searchInputRef,
        handleSubmit: handleSubmit,
        handleResetSearchKeyword: handleResetSearchKeyword,
        handleBackButtonClick: handleBackButtonClick,
        handleChangeSearchKeyword: handleChangeSearchKeyword
    };
};
/* harmony default export */ var medicine_dictionary_useMedicineDictionaryViewModel = (useMedicineDictionaryViewModel);

// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
;// CONCATENATED MODULE: ./src/pages/medicine-dictionary/index.tsx
// PageDescription: 의약품 사전 페이지





var MedicineDictionaryPage = function(param) {
    var client = param.client;
    var viewModel = medicine_dictionary_useMedicineDictionaryViewModel();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "닥터나우 의약품 사전 - 의약품 효능/효과부터 부작용까지",
                description: "모든 의약품의 효과, 부작용, 복용법, 주의사항까지. 궁금한 약 정보를 닥터나우 의약품 사전에서 확인해보세요.",
                canonical: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.MEDICINE_DICTIONARY.DETAIL.path */.Z6.MEDICINE_DICTIONARY.DETAIL.path)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(medicine_dictionary_MedicineDictionaryTemplate, {
                viewModel: viewModel,
                client: client
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var medicine_dictionary = (MedicineDictionaryPage);


/***/ }),

/***/ 45162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tq": function() { return /* binding */ AuthorType; },
/* harmony export */   "Zg": function() { return /* binding */ MagazineTagType; },
/* harmony export */   "pO": function() { return /* binding */ EDoctorCareer; },
/* harmony export */   "rL": function() { return /* binding */ MagazineType; },
/* harmony export */   "wK": function() { return /* binding */ MagazineBottomButtonType; }
/* harmony export */ });
/* unused harmony export CoreCategoryType */
var MagazineType = {
    INTERNAL: "INTERNAL",
    EXTERNAL: "EXTERNAL",
    ARTICLE: "ARTICLE",
    FAQ: "FAQ"
};
var MagazineTagType;
(function(MagazineTagType) {
    MagazineTagType["DEPARTMENT"] = "DEPARTMENT";
    MagazineTagType["SYMPTOM"] = "SYMPTOM";
    MagazineTagType["DISEASE"] = "DISEASE";
    MagazineTagType["FREE"] = "FREE";
})(MagazineTagType || (MagazineTagType = {}));
var CoreCategoryType;
(function(CoreCategoryType) {
    CoreCategoryType["Department"] = "DEPARTMENT";
    CoreCategoryType["Disease"] = "DISEASE";
    CoreCategoryType["Symptom"] = "SYMPTOM";
})(CoreCategoryType || (CoreCategoryType = {}));
var AuthorType;
(function(AuthorType) {
    AuthorType["DOCTOR"] = "DOCTOR";
    AuthorType["AI"] = "AI";
    AuthorType["NURSE"] = "NURSE";
    AuthorType["MEDICAL_PROFESSIONAL_EDITOR"] = "MEDICAL_PROFESSIONAL_EDITOR";
    AuthorType["GENERAL_EDITOR"] = "GENERAL_EDITOR";
})(AuthorType || (AuthorType = {}));
var ProfessionalFieldType;
(function(ProfessionalFieldType) {
    ProfessionalFieldType["DEPARTMENT"] = "DEPARTMENT";
})(ProfessionalFieldType || (ProfessionalFieldType = {}));
var MagazineBottomButtonType;
(function(MagazineBottomButtonType) {
    MagazineBottomButtonType["QUESTION"] = "QUESTION";
    MagazineBottomButtonType["DIAGNOSIS"] = "DIAGNOSIS";
})(MagazineBottomButtonType || (MagazineBottomButtonType = {}));
var EDoctorCareer;
(function(EDoctorCareer) {
    EDoctorCareer["CURRENT"] = "CURRENT";
    EDoctorCareer["PAST"] = "PAST";
    EDoctorCareer["GRADUATION"] = "GRADUATION";
    EDoctorCareer["COMPLETION"] = "COMPLETION";
})(EDoctorCareer || (EDoctorCareer = {}));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1498,2384,2248,9774,2888,179], function() { return __webpack_exec__(54931); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);